// removed by extract-text-webpack-plugin
module.exports = {"root":"_37Gzk","title":"_377_f","postList":"_1RhJX","cardWrapper":"_39g7H","postCard":"_3FzVg"};


//////////////////
// WEBPACK FOOTER
// ./app/components/PostList/PostList.scss
// module id = 1113
// module chunks = 1